import { generatePath } from "react-router-dom";

import { CertificationLocationState } from "@/domains/certifications/types";
import type { CertificationListItem } from "@/redux/certifications/types";

export const CERTIFICATION_ROUTE_PATTERNS = {
  ROOT: "/certifications",
  DETAILS: ":slug",
  OVERVIEW: ":slug/overview",
  MODULE: ":slug/modules/:moduleId",
  ADMIN: ":slug/admin",
  PARTICIPANT: ":slug/admin/participants/:userId",
} as const;

const absolutePattern = (pattern: string) =>
  `${CERTIFICATION_ROUTE_PATTERNS.ROOT}/${pattern}`;

export const certificationPaths = {
  index: () => CERTIFICATION_ROUTE_PATTERNS.ROOT,
  details: (slug: string) =>
    generatePath(absolutePattern(CERTIFICATION_ROUTE_PATTERNS.DETAILS), {
      slug,
    }),
  overview: (slug: string) =>
    generatePath(absolutePattern(CERTIFICATION_ROUTE_PATTERNS.OVERVIEW), {
      slug,
    }),
  module: (slug: string, moduleId: number) =>
    generatePath(absolutePattern(CERTIFICATION_ROUTE_PATTERNS.MODULE), {
      slug,
      moduleId: String(moduleId),
    }),
  admin: (slug: string) =>
    generatePath(absolutePattern(CERTIFICATION_ROUTE_PATTERNS.ADMIN), { slug }),
  participant: (slug: string, userId: number) =>
    generatePath(absolutePattern(CERTIFICATION_ROUTE_PATTERNS.PARTICIPANT), {
      slug,
      userId: String(userId),
    }),
};

export const ADMIN_TABS = {
  PARTICIPANTS: "participants",
  INVITATIONS: "invitations",
  COMMUNITY_FLAGS: "community-flags",
  KNOWLEDGE_CHECK_FLAGS: "knowledge-check-flags",
  ANALYTICS: "analytics",
} as const;

export const PATH_DECISION_ANCHOR_ID = "path-decision";

export const WELL_BEING_SLUG = "well-being";

export const certificationRouteKey = (
  certification: Pick<CertificationListItem, "type">,
) => certification.type.toLowerCase().replace(/_/g, "-");

export const FROM_OVERVIEW_STATE: CertificationLocationState = {
  fromOverview: true,
};
